<template>
    <g-modal
            v-model="modal"
            :closable="false"
            :width="null"
            wrapClassName="file-delete-modal"
            :maskStyle="{backgroundColor: 'rgba(255, 255, 255, 0.5)'}"
    >
        <div class="margin-bottom-small">
            <g-typography tag="h3" fontWeight="semibold" font-weith value="Are you sure?"/>
        </div>
        <g-typography tag="p" value="You're about to remove this file. This can't be undone."/>
        <template slot="footer">
            <div class="modal-footer">
                <g-button @click="handleCancel">Cancel</g-button>
                <g-button @click="handleDelete" type="danger" theme="live">Delete</g-button>
            </div>
        </template>
    </g-modal>
</template>

<script>
    export default {
        name: "FileDeleteModal",
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                modal: false,
            };
        },
        methods: {
            handleDelete() {
                this.$emit('modal-delete');
            },
            handleCancel() {
                this.$emit('modal-cancel');
            },
        },
        watch: {
            visible(val) {
                this.modal = val;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .modal-footer {
        display: flex;
        justify-content: flex-end;
        padding: $g-spacing-7;
    }
    .margin-bottom-small {
        margin-bottom: $g-spacing-3;
    }
</style>

<style lang="scss">
    .file-delete-modal .ant-modal {
        width: $g-screen-size-xs;
        padding: $g-spacing-5;
    }
    .file-delete-modal .ant-modal-body {
        padding: $g-spacing-7;
    }
    .file-delete-modal .ant-modal-footer {
        border: none;
        padding: 0;
    }
</style>